import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import cx from 'classnames';
import { Icon } from '../Icon';
import React, { Component, PropsWithChildren, MouseEvent } from 'react';
import smoothScrollIntoView from 'smooth-scroll-into-view-if-needed';
import { INaturalFieldDisplayOptionProps } from './types';

export class NaturalFieldOption extends Component<PropsWithChildren<INaturalFieldDisplayOptionProps>, {}> {
  public render() {
    const { display, highlighted, id, multiple, selected, value, disabled = false } = this.props;
    const classes = cx('nl-select-option', {
      disabled: !!disabled,
      highlighted: !!highlighted,
      multiple,
      selected,
    });
    return (
      <a
        id={id}
        title={typeof value === 'string' ? value : display}
        onClick={this.onClick}
        className={classes}
        role={'option'}
        aria-selected={selected || undefined}
        ref={(ref) => {
          if (ref && highlighted) {
            smoothScrollIntoView(ref);
          }
        }}
      >
        {multiple && (
          <input
            type="checkbox"
            checked={selected}
            tabIndex={-1}
            onChange={() => {
              // noop
            }}
            disabled={disabled}
          />
        )}
        <span className="nl-select-option-display">{display || value}</span>
        {!multiple && selected && <Icon icon={faCheck} size="sm" className={'nl-check'} />}
      </a>
    );
  }

  private onClick = (
    event: MouseEvent<HTMLAnchorElement> | MouseEvent<HTMLInputElement> | React.KeyboardEvent<HTMLAnchorElement>,
  ) => {
    const { disabled = false, onClick } = this.props;
    event.stopPropagation();
    if (!disabled) {
      onClick(this.props.value);
    }
  };
}
export default NaturalFieldOption;
